<template>
  <Header title="Wedding" />
  <section class="inner_banner_slider_section top_margin">
    <div class="inner_banner_slider_row">
      <div class="inner_banner_slider_btn_col">
        <div class="inner_banner_slider_btn_block">
          <div class="top_btn_outter">
            <div class="top_btn_inner share_btn_inner">
              <a
                class="btn share_btn"
                data-toggle="modal"
                data-target="#myModal"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.9374 1.6249C21.291 1.6249 20.671 1.88171 20.2139 2.33883C19.7568 2.79595 19.4999 3.41594 19.4999 4.0624C19.4999 4.70887 19.7568 5.32885 20.2139 5.78597C20.671 6.24309 21.291 6.4999 21.9374 6.4999C22.5839 6.4999 23.2039 6.24309 23.661 5.78597C24.1181 5.32885 24.3749 4.70887 24.3749 4.0624C24.3749 3.41594 24.1181 2.79595 23.661 2.33883C23.2039 1.88171 22.5839 1.6249 21.9374 1.6249ZM17.8749 4.0624C17.8748 3.10923 18.2099 2.18636 18.8215 1.45527C19.433 0.724173 20.2822 0.231403 21.2204 0.0631728C22.1586 -0.105058 23.1261 0.0619642 23.9536 0.535016C24.7811 1.00807 25.416 1.75703 25.747 2.65086C26.0781 3.54469 26.0843 4.52647 25.7646 5.42443C25.4449 6.32239 24.8197 7.07936 23.9983 7.56288C23.1768 8.04641 22.2116 8.22571 21.2713 8.06941C20.331 7.91311 19.4756 7.43117 18.8548 6.7079L7.93807 11.7779C8.18903 12.5732 8.18903 13.4266 7.93807 14.2219L18.8548 19.2919C19.5111 18.5287 20.4273 18.0363 21.4259 17.9101C22.4245 17.7839 23.4344 18.0329 24.2599 18.6089C25.0853 19.1849 25.6676 20.0468 25.8938 21.0276C26.12 22.0084 25.974 23.0383 25.4841 23.9176C24.9943 24.7969 24.1955 25.4631 23.2424 25.787C22.2894 26.1109 21.2501 26.0694 20.3259 25.6707C19.4017 25.272 18.6584 24.5443 18.2401 23.6288C17.8218 22.7133 17.7583 21.6751 18.0618 20.7154L7.14507 15.6454C6.60465 16.2752 5.88431 16.7244 5.08096 16.9325C4.2776 17.1407 3.42977 17.0978 2.65152 16.8097C1.87326 16.5215 1.20192 16.002 0.727792 15.3209C0.253668 14.6398 -0.000488281 13.8298 -0.000488281 12.9999C-0.000488281 12.17 0.253668 11.36 0.727792 10.6789C1.20192 9.99782 1.87326 9.47826 2.65152 9.19012C3.42977 8.90199 4.2776 8.85911 5.08096 9.06726C5.88431 9.27541 6.60465 9.7246 7.14507 10.3544L18.0618 5.2844C17.9376 4.88899 17.8745 4.47688 17.8749 4.0624ZM4.06244 10.5624C3.41598 10.5624 2.79599 10.8192 2.33887 11.2763C1.88175 11.7334 1.62494 12.3534 1.62494 12.9999C1.62494 13.6464 1.88175 14.2664 2.33887 14.7235C2.79599 15.1806 3.41598 15.4374 4.06244 15.4374C4.70891 15.4374 5.3289 15.1806 5.78602 14.7235C6.24314 14.2664 6.49994 13.6464 6.49994 12.9999C6.49994 12.3534 6.24314 11.7334 5.78602 11.2763C5.3289 10.8192 4.70891 10.5624 4.06244 10.5624ZM21.9374 19.4999C21.291 19.4999 20.671 19.7567 20.2139 20.2138C19.7568 20.6709 19.4999 21.2909 19.4999 21.9374C19.4999 22.5839 19.7568 23.2039 20.2139 23.661C20.671 24.1181 21.291 24.3749 21.9374 24.3749C22.5839 24.3749 23.2039 24.1181 23.661 23.661C24.1181 23.2039 24.3749 22.5839 24.3749 21.9374C24.3749 21.2909 24.1181 20.6709 23.661 20.2138C23.2039 19.7567 22.5839 19.4999 21.9374 19.4999Z"
                    fill="white"
                  />
                </svg>
              </a>
              <!-- Modal -->
              <div id="myModal" class="modal fade" role="dialog">
                <div class="modal-dialog">
                  <!-- Modal content-->
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal">
                        &times;
                      </button>
                    </div>
                    <div class="modal-body text-center">
                      <p class="data_sub_heading tc">
                        Do you like this? Share with your friends!
                      </p>
                      <div class="model_popup_img_box">
                        <img
                          src="../../src/assets/images/inner_page/wedding_inner_1.jpg"
                          class="model_popup_img"
                        />
                      </div>
                      <div class="model_popup_icon_box">
                        <ul class="share_links">
                          <li class="bg_fb">
                            <a
                              href="#"
                              class="share_icon"
                              rel="tooltip"
                              title="Facebook"
                              ><i class="fa fa-facebook"></i
                            ></a>
                          </li>
                          <li class="bg_insta">
                            <a
                              href="#"
                              class="share_icon"
                              rel="tooltip"
                              title="Instagram"
                              ><i class="fa fa-instagram"></i
                            ></a>
                          </li>
                          <li class="bg_whatsapp">
                            <a
                              href="#"
                              class="share_icon"
                              rel="tooltip"
                              title="Whatsapp"
                              ><i class="fa fa-whatsapp" aria-hidden="true"></i
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END -->
            </div>
            <!-- <div class="top_btn_inner view_photo_btn_inner">
                            <div class="photos_see_all-btn-container">
                                <a href="" data-lightbox="models" data-title="STRUCTURE">
                                    <span>View Photos</span>
                                </a>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
      <div class="inner_banner_slider_col">
        <div class="inner_banner_slider_block">
          <div class="gallery inner_banner_slider">
            <Carousel
              ref="villas"
              :items-to-show="1"
              :wrap-around="true"
              :autoplay="2000"
            >
              <Slide key="1">
                <img
                  src="../../src/assets/images/inner_page/wedding_inner_1.jpg"
                />
              </Slide>
              <Slide key="2">
                <img
                  src="../../src/assets/images/inner_page/wedding_inner_2.jpg"
                />
              </Slide>
              <Slide key="3">
                <img
                  src="../../src/assets/images/inner_page/wedding_inner_3.jpg"
                />
              </Slide>
              <Slide key="4">
                <img
                  src="../../src/assets/images/inner_page/wedding_inner_4.jpg"
                />
              </Slide>
            </Carousel>
          </div>
        </div>
      </div>
      <div class="inner_banner_col">
        <div class="inner_banner_block">
          <p class="body_heading tc" id="weddingPackage">Weddings</p>
        </div>
      </div>
    </div>
  </section>
  <!-- ----------- data & Explore the Villa & Amenities ----------- -->
  <section class="villa_data_section row_padding">
    <div class="villa_data_row main_container">
      <div class="villa_data_col villa_left_col">
        <div class="villa_left_block">
          <div class="body_heading_block desk_heading">
            <p class="body_heading">Making your best moment extra special!</p>
            <div class="small_body_font">
              <p>
                The architecture of Rio Colina has spread over 48 acres of land
                that seamlessly blends with the landscape. Say your vows against
                the backdrop of golden sunsets amidst the sound of nature and
                lush greenery. Whether you want a small intimate celebration
                with your loved ones or looking for a big fat Indian wedding, we
                have got you covered!
              </p>
              <p>
                Being one of the best wedding venues in Surat, our professional
                wedding planners won’t let you worry about a single thing. Just
                sit back, relax, and let our fingers do the magic for you.
              </p>
              <p>
                Only an hour's drive away from Sun City, the picturesque
                landscape and our luxurious amenities will give you the wedding
                of your dreams.
              </p>
            </div>
            <div class="btn_block btn_center_block wedding_btn">
              <div class="bird bird--one">
                <div class="btn_border block_cta">
                  <a
                    href="https://www.youtube.com/watch?v=0piTRDF-w0g"
                    class="site_button"
                    target="_blank"
                  >
                    <div class="site_button_div">
                      <span class="btn_text">Take a Tour Of Rio</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="villa_left_block villa_left_block_02">
          <div class="body_heading_block">
            <p class="body_heading">Weddings At Club Rio</p>
          </div>
          <div class="villa_features_block">
            <p class="font_20 villa_features_main_heading">Inclusion</p>
            <!-- Other spaces -->
            <div class="villa_features_outter">
              <div class="villa_features_inner">
                <div class="villa_features_inner_box">
                  <div class="villa_features_img">
                    <img
                      src="../assets/images/inner_page/wedding/Swimming pool.png"
                    />
                  </div>
                  <div class="villa_features_info">
                    <p class="body_font villa_feature_title tc">
                      Swimming Pool
                    </p>
                  </div>
                </div>
              </div>
              <div class="villa_features_inner">
                <div class="villa_features_inner_box">
                  <div class="villa_features_img">
                    <img
                      src="../assets/images/inner_page/wedding/Housekeeping.png"
                    />
                  </div>
                  <div class="villa_features_info">
                    <p class="body_font villa_feature_title tc">
                      House Keeping
                    </p>
                  </div>
                </div>
              </div>
              <div class="villa_features_inner">
                <div class="villa_features_inner_box">
                  <div class="villa_features_img">
                    <img
                      src="../assets/images/inner_page/wedding/Valet parking.png"
                    />
                  </div>
                  <div class="villa_features_info">
                    <p class="body_font villa_feature_title tc">
                      Valet Parking
                    </p>
                  </div>
                </div>
              </div>
              <div class="villa_features_inner">
                <div class="villa_features_inner_box">
                  <div class="villa_features_img">
                    <img
                      src="../assets/images/inner_page/wedding/Banquet hall.png"
                    />
                  </div>
                  <div class="villa_features_info">
                    <p class="body_font villa_feature_title tc">Banquet Hall</p>
                  </div>
                </div>
              </div>
              <div class="villa_features_inner">
                <div class="villa_features_inner_box">
                  <div class="villa_features_img">
                    <img
                      src="../assets/images/inner_page/wedding/Event Managers.png"
                    />
                  </div>
                  <div class="villa_features_info">
                    <p class="body_font villa_feature_title tc">
                      Event Managers
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="btn_block btn_center_block wedding_pdf_btn">
                        <div class="btn_border block_cta">
                            <div class="bird bird--one">
                                <a href="#" class="site_button">
                                    <div class="site_button_div">
                                        <span class="btn_text">Floor Plan Pdf</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
      <div class="villa_data_col villa_right_col" id="wrapper_box">
        <div class="villa_right_block" id="sticky_box">
          <div class="wedding_right_box">
            <div class="tab">
              <button
                class="tablinks week_tab_active box_title_text"
                @click="openCity($event, 'weekdaytab')"
              >
                Wedding Package's for 2 day’s
              </button>
              <!-- <button class="tablinks box_title_text" @click="openCity($event, 'weekendtab')">Weekend</button> -->
            </div>
            <div id="weekdaytab" class="tabcontent main_active">
              <div class="tab_content_outter">
                <div class="tab_content_inner">
                  <div class="tab_content_block">
                    <div class="padding_box">
                      <p class="price_cal_title">
                        Total Package for 2 day’s Wedding Price
                      </p>
                    </div>
                    <div class="padding_box py-0">
                      <p class="price_cal_num">
                        ₹ 25,00,000 <span>(18% GST INC.)</span>
                      </p>
                    </div>
                    <div class="separater"></div>
                    <div class="second_box padding_box">
                      <div class="amount_box">
                        <p class="body_font tc">
                          Security Deposite: <span>₹ 1,00,000 /-</span>
                        </p>
                        <p class="body_font tc">
                          Security Deposit [Kitchen]: <span>₹ 30,000 /-</span>
                        </p>
                        <p class="body_font tc">
                          Kitchen Cleaning Charges:
                          <span>₹ 20,000/- (2 days)</span>
                        </p>
                        <p class="body_font tc">
                          Swimming pool: <span>4 hours</span>
                        </p>
                        <p class="body_font tc">
                          Pool party: <span>4 hours</span>
                        </p>
                        <p class="body_font tc">
                          3BHK Villa: <span>45 Villas for 2 days.</span>
                        </p>
                        <p class="body_font tc">
                          Riverside Cottage: <span>12 Cottages for 2 days</span>
                        </p>
                        <br />
                        <p>*Additional charges applied for more villas</p>
                        <!-- <p class="body_font tc">Check In: <span>2:00</span> & Check Out:
                                                        <span>12:00</span>
                                                    </p> -->
                      </div>
                      <div class="btn_block btn_center_block">
                        <div class="btn_border block_cta">
                          <a href="tel:18008913918" class="site_button">
                            <div class="site_button_div">
                              <span class="font_20">Call now</span>
                            </div>
                          </a>
                          <!-- <a href="#" class="site_button">
                                                        <div class="site_button_div">
                                                            <span class="font_20">Call Now</span>
                                                        </div>
                                                    </a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div id="weekendtab" class="tabcontent">
                                <div class="tab_content_outter padding_box">
                                    <div class="tab_content_inner">
                                        <div class="tab_content_block">
                                            <p class="small_body_font wt">Lorem Ipsum is simply dummy text of the printing and
                                                typesetting industry. Lorem Ipsum has been the industry's standard dummy text
                                                ever since.</p>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ---------- FILLER SECTION ---------- -->
  <Download />
  <!-- ---------- Weddings Events ---------- -->
  <section class="pro_box_section explore_luxury_section weddings_section">
    <div class="explore_luxury_row row_padding main_container">
      <div class="pro_box_col">
        <div class="main_title_block">
          <div class="body_heading_block desk_heading">
            <p class="body_heading tc">Create lasting memories together</p>
            <p class="notes_center">*Extra charges applied.</p>
          </div>
        </div>
        <div class="main_box_block">
          <div class="pro_box">
            <!-- box 01 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_01" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">
                              Pre-Wedding PhotoShoot
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 02 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_02" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Farm Party</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 03 -->

            <!-- box 04 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_birthday" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Birthday Parties</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ---------- Weddings Events ---------- -->
  <section class="pro_box_section explore_luxury_section weddings_section">
    <div class="explore_luxury_row row_padding main_container">
      <div class="pro_box_col">
        <div class="main_title_block">
          <div class="body_heading_block desk_heading">
            <p class="body_heading tc">Weddings Events</p>
          </div>
        </div>
        <div class="main_box_block">
          <div class="pro_box">
            <!-- box 03 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_03" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Mehandi</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 04 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_04" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Sangeet Sandhya</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 05 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_05" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Mangalik Vidhis</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 06 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_06" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Wedding</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 07 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_07" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Royal Dinner</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 08 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_08" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Reception</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- box 09 -->
            <div class="pro_box_block">
              <div class="box_outter_box">
                <div class="box_inner_box">
                  <div class="box_img_block">
                    <img :src="WE_09" class="box_img" />
                    <div class="btn_block btn_center_block">
                      <div class="btn_border block_cta">
                        <!-- <div class="bird_hover_opacity bird bird--one">
                                                <a href="#" class="site_button">
                                                    <div class="site_button_div">
                                                        <span class="btn_text">View More</span>
                                                    </div>
                                                </a>
                                            </div> -->
                        <div class="bird_hover_opacity bird bird--one">
                          <a href="#weddingPackage" class="site_button">
                            <div class="site_button_div">
                              <span class="btn_text">Call Now</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box_data_block">
                    <div class="box_data">
                      <div class="box_body_text text_center box_details_block">
                        <div class="box_details">
                          <div class="box_title_text_box">
                            <p class="box_title_text tc">Banquet By The Pool</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ---------- FACILITIES SECTION ---------- -->
  <section class="facilities_section row_padding">
    <div class="rules_row main_container">
      <div class="rules_col">
        <div class="rules_block">
          <div class="rules_left_block">
            <div class="body_heading_block">
              <p class="body_heading">Facilities</p>
            </div>
            <div class="rules_features_outter">
              <div class="rules_features_block">
                <div class="rules_outter">
                  <div class="small_body_font">
                    <ul>
                      <li>4 Private gardens with river views.</li>
                      <li>Luxurious Banquet hall.</li>
                      <li>Separate space for kitchen and catering services.</li>
                      <li>
                        Lavis villas & Exclusive Riverside cottages to
                        accommodate guests.
                      </li>
                      <li>Surrounded by nature and river.</li>
                      <li>Unlimited parking space.</li>
                      <li>
                        *Luxurious villas with river views. (Extra charges
                        applied)
                      </li>
                      <li>DiscoTheque (Extra charges applied)</li>
                      <li>Surrounded by nature and river.</li>
                      <li>Beautiful locations to take pictures.</li>
                      <li>Stress free weddings operating since 2014.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ---------- REVIEW FILLER SECTION ---------- -->
  <!-- <section class="review_section row_padding review_vector_section">
        <div class="review_row main_container">
            <div class="review_col">
                <div class="review_block">
                    <p class="body_heading tc">Reviews and Rating</p> 
                    <div class="feed_block">
                        <img :src="feedback">
                        <p class="font_20">Write a review</p>
                    </div>
                </div>
            </div>
            <div class="right_vector_outter_box">
                <div class="right_svg_move">
                    <svg width="454" height="51" viewBox="0 0 454 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M453.262 32.5001C453.262 32.5001 355.762 -5.00003 274.762 28C193.762 61.0001 149.501 58.5 9.50098 9.5" stroke="black" stroke-dasharray="2 2"/>
                        <path d="M14.5234 1.01465L1.04282 6.64648L7.57913 20.5322" stroke="black" stroke-dasharray="2 2"/>
                    </svg>
                </div>
                <img :src="right_single_title" alt="" class="right_vector_animation">
            </div>
        </div>
    </section> -->
  <Footer />
</template>

<script>
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
// import GP_btn_01 from '../assets/images/GP_btn_01.png';
import GP_btn_01Png from "../assets/images/gp-img.png";
import AS_btn_01Png from "../assets/images/as-img.png";
import WE_01 from "../assets/images/inner_page/WE_01.jpg";
import WE_02 from "../assets/images/inner_page/WE_02.jpg";
import WE_birthday from "../assets/images/inner_page/birthday parties.jpg";
import WE_03 from "../assets/images/inner_page/WE_03.jpg";
import WE_04 from "../assets/images/inner_page/WE_04.jpg";
import WE_05 from "../assets/images/inner_page/WE_05.jpg";
import WE_06 from "../assets/images/inner_page/WE_06.jpg";
import WE_07 from "../assets/images/inner_page/WE_07.jpg";
import WE_08 from "../assets/images/inner_page/WE_08.jpg";
import WE_09 from "../assets/images/inner_page/WE_09.jpg";
import feedback from "../assets/images/inner_page/feedback.png";
import right_single_title from "../assets/images/right_single_title.png";
import CR_01 from "../assets/images/inner_page/CR_01.png";
import CR_02 from "../assets/images/inner_page/CR_02.png";
import CR_03 from "../assets/images/inner_page/CR_03.png";
import CR_04 from "../assets/images/inner_page/CR_04.png";
import CR_05 from "../assets/images/inner_page/CR_05.png";
import CR_06 from "../assets/images/inner_page/CR_06.png";
import CR_07 from "../assets/images/inner_page/CR_07.png";
import CR_08 from "../assets/images/inner_page/CR_08.png";
import CR_09 from "../assets/images/inner_page/CR_09.png";
import CR_10 from "../assets/images/inner_page/CR_10.png";
import CR_11 from "../assets/images/inner_page/3BHK_Villa.png";
import CR_12 from "../assets/images/inner_page/housekeeping.png";
import CR_13 from "../assets/images/inner_page/riverside_cottage.png";
import filler_img from "../assets/images/filler_img.png";

import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

import Download from "@/pages/Download.vue";

export default {
  name: "Wedding",
  components: { Header, Footer, Carousel, Slide, Download },
  data() {
    return {
      GP_btn_01Png: GP_btn_01Png,
      AS_btn_01Png: AS_btn_01Png,
      WE_01: WE_01,
      WE_02: WE_02,
      WE_birthday: WE_birthday,
      WE_03: WE_03,
      WE_04: WE_04,
      WE_05: WE_05,
      WE_06: WE_06,
      WE_07: WE_07,
      WE_08: WE_08,
      WE_09: WE_09,
      feedback: feedback,
      right_single_title: right_single_title,
      CR_01: CR_01,
      CR_02: CR_02,
      CR_03: CR_03,
      CR_04: CR_04,
      CR_05: CR_05,
      CR_06: CR_06,
      CR_07: CR_07,
      CR_08: CR_08,
      CR_09: CR_09,
      CR_10: CR_10,
      CR_11: CR_11,
      CR_12: CR_12,
      CR_13: CR_13,
      filler_img: filler_img,
    };
  },
  mounted() {
    let recaptchaScript2 = document.createElement("script");
    recaptchaScript2.setAttribute("src", "./js/slick/slick.js");
    document.head.appendChild(recaptchaScript2);
    let recaptchaScript3 = document.createElement("script");
    recaptchaScript3.setAttribute("src", "./js/slick/slick.min.js");
    document.head.appendChild(recaptchaScript3);
    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "./js/script.js");
    document.head.appendChild(recaptchaScript);

    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  methods: {
    openCity(evt, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(
          " week_tab_active",
          ""
        );
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " week_tab_active";
    },
  },
};
</script>

<style scoped>
.lb-data .lb-close {
  width: 508px;
  position: absolute;
  top: 21px;
  right: 0;
  left: 0;
  margin: auto;
}

.padding_box.py-0 {
  padding-top: 0 !important;
}

.wedding_right_box .block_cta .site_button:nth-child(1) {
  margin-right: 0px;
}

.lightbox {
  left: 0px;
  padding-top: 50px;
}

@media all and (max-width: 991px) {
  .pro_box_block {
    width: 100%;
    padding-right: 15px;
    padding-left: 5px;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .villa_features_inner {
    height: 130px;
    width: 100%;
    padding: 5px;
  }

  .review_block,
  .rules_features_outter {
    display: flex;
  }
}

.notes_center {
  color: red;
  text-align: center;
}
</style>
